const coins = require('../coins');
const REFERENCE_ASSETS = require('../reference-assets.js');

module.exports = [{
    dataIndex: 0,
    id: '3pool',
    name: '3pool',
    lpTokenInfo: {
        name: '3poolCurve',
        symbol: '3poolCrv',
    },
    assets: 'DAI+USDC+USDT',
    coins: [
        coins.dai,
        coins.usdc,
        coins.usdt,
    ],
    addresses: {
        swap: '0xace58a26b8db90498ef0330fdc9c2655db0c45e2',
        lpToken: '0xace58a26b8db90498ef0330fdc9c2655db0c45e2',
        gauge: '0xace58a26b8db90498ef0330fdc9c2655db0c45e2',
    },
    hasNoGauge: true,
    // gaugeVersion: 3, // No CRV rewards
    hasNoCRVRewards: true,
  }
];
